export default function showDashboardOnNavbar(session){var _session$user;/**
   * Show "Dashboard" on Navbar if...
   * 1. User is logged in
   * 2. User's accreditation is in review or verified
   */if(!session)return false;if((_session$user=session.user)!==null&&_session$user!==void 0&&_session$user.accreditationStatus){return true;}return false;}